import { IInputMethodBehaviorSpecifiable, IInputMethodBehavior, InputMethodKinds } from "../../../../../../../documaker/domain/format/objects";
import { IObjectBeanInputMethodControllable } from "../../../beans/objects";
import { MapTranslator } from "../../values";

export class InputMethodBehaviorTranslator {
  from(bean: IObjectBeanInputMethodControllable): IInputMethodBehavior {
    return {
      kind: this.kind.from(bean["@input-code"]),
    };
  }

  to(object: IInputMethodBehaviorSpecifiable) {
    return {
      inputCode: this.kind.to(object.inputMethodBehavior.kind),
    };
  }

  private readonly kind = new MapTranslator<InputMethodKinds, string>([
    { object: InputMethodKinds.HalfWidthNumberOnly,   bean: "1" },
    { object: InputMethodKinds.HalfWidthOnly,         bean: "2" },
    { object: InputMethodKinds.FullWidthOnly,         bean: "3" },
    { object: InputMethodKinds.HalfWidthAlphabetOnly, bean: "4" },
  ], InputMethodKinds.None, undefined);
}
